import { render, staticRenderFns } from "./EvaluationReport.vue?vue&type=template&id=5ec556fb&scoped=true&"
import script from "./EvaluationReport.vue?vue&type=script&lang=js&"
export * from "./EvaluationReport.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationReport.vue?vue&type=style&index=0&id=5ec556fb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ec556fb",
  null
  
)

export default component.exports